<app-breadcrumb></app-breadcrumb>
<div class="table-container" style="border: 1px solid #cfcfcf;">
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <div id="serach-field-container" class="row">
    <div class="col-md-3">
      <div><label for="email ">User Name</label></div>
      <input class="search-filed-continers uppercase" type="text" [(ngModel)]="searchingByUserName">
    </div>
    <div class="col-md-3">
      <div><label for="email">First Name</label></div>
      <input class="search-filed-continers" type="text" [(ngModel)]="searchingByFirstName">
    </div>
    <div class="col-md-3">
      <div><label for="email">Last Name</label></div>
      <input class="search-filed-continers" type="text" [(ngModel)]="searchingByLastName">
    </div>
    <div class="col-md-3">
      <div><label for="email">Email Address</label></div>
      <input class="input-filed-continers" type="email" [(ngModel)]="searchByemailAddress">
    </div>
    <div class="col-md-3">
      <div><label for="email">Designation</label></div>

      <mat-select matInput placeholder="Select" [(ngModel)]="designationSearchingCodeValue"
        (closed)="designationsearchTxt=''" (click)="focusmethod('designationfocusSearch')"
        (keydown.enter)="focusmethod('designationfocusSearch')">
        <input type="search" id="designationfocusSearch" class="dropdownsearchstyle" [(ngModel)]="designationsearchTxt"
          matInput placeholder="Search">
        <mat-option class="unselectStyle" [value]="null"
          (onSelectionChange)="onDesignationCodeSelect($event,null);">Un-select</mat-option>
        <mat-option *ngFor="let item of designationCodeDropdown| assessmentSearch :designationsearchTxt"
          (onSelectionChange)="onDesignationCodeSelect($event,item)" [value]="item.valueExp">
          {{ item.displayExp }}
        </mat-option>
      </mat-select>
    </div>
    <div class="col-md-3">
      <div><label for="email">Department</label></div>
      <mat-select matInput placeholder="Select" [(ngModel)]="departmentSearchingCodeValue"
        (closed)="departmentsearchTxt=''" (click)="focusmethod('departmentfocusSearch')"
        (keydown.enter)="focusmethod('departmentfocusSearch')">
        <input type="search" id="departmentfocusSearch" class="dropdownsearchstyle" [(ngModel)]="departmentsearchTxt"
          matInput placeholder="Search">
        <mat-option class="unselectStyle" [value]="null"
          (onSelectionChange)="onDepartmentCodeSelect($event,null);">Un-select</mat-option>
        <mat-option *ngFor="let item of departmentCodeDropdown| assessmentSearch :departmentsearchTxt"
          (onSelectionChange)="onDepartmentCodeSelect($event,item)" [value]="item.valueExp">
          {{ item.displayExp }}
        </mat-option>
      </mat-select>
    </div>
    <div class="col-md-3">
      <div><label for="email">Status</label></div>

      <mat-select matInput multiple placeholder="Select" #statusSearch [(ngModel)]="statusCodeValue"
        (closed)="statusSearchText=''" (click)="focusSearch('searchStatusfocus')"
        (keydown.enter)="focusSearch('searchStatusfocus')">
        <input type="search" id="searchStatusfocus" class="dropdownsearchstyle" [(ngModel)]="statusSearchText" matInput
          placeholder="Search">
        <div class="select-all">
          <mat-checkbox [(ngModel)]="isStatusSearchSelected" (change)="toggleAllSelectionOthers('searchStatus')">Select
            All</mat-checkbox>
        </div>
        <mat-option *ngFor="let item1 of searchByStatusDropdown | multiAssessmentSearchPipe :statusSearchText"
          [value]="item1.valueExp" (onSelectionChange)="onStatusCodeSelectAll($event, item1)">
          {{ item1.displayExp }}
        </mat-option>
      </mat-select>

    </div>
  </div>
  <div class="row">
    <div class="search-button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="searchButton" (click)="getcallMethod()">
        <i class="fa-solid fa-magnifying-glass"></i> Search
      </button>
      <button mat-stroked-button class="cancelButton" (click)="gridResetFunction()">
        <i class="fa fa-repeat"></i> Reset
      </button>
    </div>
  </div>
</div>
<section class="position-relative grid-content">
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center px-3">
        <div class="dropdown">
        </div>
      </div>
      <div class="d-flex gap-3">
        <div id="header-container" *ngIf="visibleDataGrid">
          <div class="">
            <div class="search-container">
              <span class="fa fa-search form-control-feedback"></span>
              <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
                (input)="applyFilter2($event)" [(ngModel)]="searchValue" />
            </div>
          </div>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
            <path style="fill:'#FFFFFF'"
              d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
          </svg>
          <span class="reload_text text-white">Settings</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openAddPopup()"
          (keydown.enter)="openAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')" *ngIf="oneQmsUsersDataForTable1.length">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Pdf')"
          (keydown.enter)="openReport('Pdf')" *ngIf="oneQmsUsersDataForTable1.length">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser && oneQmsUsersDataForTable1.length"
          (click)="openAuditTrail('overAll',0,'USER')" (keydown.enter)="openAuditTrail('overAll',0,'USER')">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshGridData()" (keydown.enter)="refreshGridData()" *ngIf="visibleDataGrid">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>

  <div class="table-container" *ngIf="visibleDataGrid">

    <table class="dynamic-table-container">
      <th style="min-width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div>
            <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
          </div>

        </div>
      </th>

      <th class="grid-header-container" *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray;
      let ix = index" [ngStyle]="{
      'min-width': oneQmsUsersDataForTable1Data.width,
      'max-width': oneQmsUsersDataForTable1Data.width,
      'overflow': 'hidden',
      'text-overflow': 'ellipsis',
      'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssfunction(0)" (focus)="focusEmpty()">
        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
          <span>{{ oneQmsUsersDataForTable1Data.fieldColumnarray }}</span>
          <div class="d-flex gap-2 align-items-center">
            <div (click)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)"
              (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)">
              <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
            </div>
            <div>
              <img src="../../../assets/img/qms_img/filter.svg" width="24px" height="24px" alt="filter" />
            </div>
          </div>
        </div>
        <div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
          </div>
        </div>
      </th>
      <th id="menu" class="sticky-col first-col"></th>
      <tr *ngFor="let list of pagedItems   let idx = index;" [class.highlightRow]="list.childCheckBoxs == true">
        <td style="min-width: 60px; text-align: center;background: white;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div>
              <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                (change)="dataGridChildCheckBoxChecked($event, list, idx)">
            </div>
          </div>
        </td>
        <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
          class="sticky-dynamic-row1" [ngStyle]="{
              'min-width': key.width[i],
              'max-width': key.width[i],
              'overflow': 'hidden',
              'text-overflow': 'ellipsis',
              'white-space': 'nowrap'}" (mouseover)="cssfunction(i)" (focus)="focusEmpty()">
          <span *ngIf="key.dataType=='CHECKBOX'">
            <div class="gridCheckBoxes">
              <img alt="yes" *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" width="20"
                height="20">
              <img alt="no" *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20">
            </div>
          </span>
          <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'" [ngStyle]="getStyle(key, list, i)">
            {{ list[key.columnsListarray] }}
          </span>
          <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
        </td>
        <td class="sticky-col first-col">
          <div class="action-icons">
            <ng-container
              *ngIf="list.USER_STATUS != 'User Deactivated' && list.USER_STATUS != 'Deactivation Approval Pending'">
              <span matTooltip="Upload profile" (click)="openUserImageUploadPopup(list)"
                (keydown.enter)="openUserImageUploadPopup(list)">
                <span
                  *ngIf="qmsservice.getOneQmsOrgUsersDetails == null || qmsservice.getOneQmsOrgUsersDetails == undefined || true">
                  <i class="fa-regular fa-circle-user" style="font-size: 20px;"></i>
                </span>
              </span>
              <i class="fa-solid fa-key" matTooltip="Reset Password" style="margin-left: 5px;"
                (click)="resetPassword(list)" (keydown.enter)="resetPassword(list)"
                *ngIf="list.USER_STATUS != 'User Deactivated' && list.USER_STATUS != 'Deactivation Approval Pending'"></i>
              <i class=" fa-solid fa-user-gear" matTooltip="User Privilege" style="margin-left: 5px;"
                (click)="configuration(list)" (keydown.enter)="configuration(list)"></i>
              <span class="active-inActiveUsers" [ngStyle]="list.IS_ACTIVE ? { color: 'red' } : { color: 'green' }"
                (click)="openActiveAndInActivePopup(list)" (keydown.enter)="openActiveAndInActivePopup(list)"
                [matTooltip]="list.IS_ACTIVE ? 'Inactivate' : 'Activate'">
                <i *ngIf="list.IS_ACTIVE" class="fas fa-lock"></i>
                <i *ngIf="!list.IS_ACTIVE" class="fas fa-lock-open"></i>
              </span>
            </ng-container>
            <i *ngIf="list.USER_STATUS != 'User Deactivated' && list.USER_STATUS != 'Deactivation Approval Pending'"
              class=" fa-solid fa-pencil" matTooltip="Edit User" style="margin-left: 5px;"
              (click)="openEditPopup(list, true)" (keydown.enter)="openEditPopup(list, true)"></i>
            <i *ngIf="list.USER_STATUS == 'User Deactivated' || list.USER_STATUS == 'Deactivation Approval Pending'"
              class="fa fa-eye" matTooltip="View User" style="margin-left: 5px;" (click)="openEditPopup(list, true)"
              (keydown.enter)="openEditPopup(list, true)"></i>
            <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
              src="../../assets/img/trail-individual.svg" (click)="openAuditTrail('individual',list,'USER')"
              (keydown.enter)="openAuditTrail('individual',list,'USER')" />
          </div>
        </td>
      </tr>
    </table>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>



<mat-menu #openMultiFilterMenu="matMenu" [hasBackdrop]="true">
  <div class="filter-menu" (click)="$event.stopPropagation();" (keydown)="$event.stopPropagation()">
    <div style="width:100%; margin-top: 5px;">
      <ng-multiselect-dropdown class="multiselect-container" [settings]="userNameDropdownSettings"
        [data]="userNameDropdown" (onSelect)="onItemSelect($event)" (onDeSelect)="onItemRemoved($event)">
      </ng-multiselect-dropdown>
    </div>
  </div>
</mat-menu>

<ng-template #updateMessagePopup>
  <div class="updateMessage-container">
    <span>Data has been not changed...</span>
  </div>
</ng-template>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="border:0.2px solid rgb(235, 232, 232);" class="p-1 m-2 d-flex justify-content-end"
      *ngIf="visibleEditButton">
      <div class="ng-template-container">
        <div class="">
          <span class="crDetail-status1" [ngStyle]="statusAppearance(oneQmsUsersFieldData.userStatus)">
            User Status&nbsp;:&nbsp; <span>{{ this.oneQmsUsersFieldData.userStatus }}</span>
          </span>
        </div>
      </div>
    </div>
    <div style="border:0.2px solid rgb(235, 232, 232);" class="p-1 m-2">
      <div class="form-continer" style="max-height: 450px !important" autocomplete="off">
        <div class="row">
          <div class="col-md-3">
            <!-- User Name -->
            <ng-container *ngIf="!oneQmsUsersFieldData.isAdUser">
              <div>
                <label for="userName" id="user-name-v">{{dynamicLabel['USER_NAME']}}</label>
                <span class="mandatory-symbol">*</span>
              </div>
              <div>
                <input id="userName" class="input-filed-continers uppercase" type="text" [disabled]="visibleEditButton"
                  [ngClass]="{'disabled-symbol': visibleEditButton}" [(ngModel)]="oneQmsUsersFieldData.userName"
                  (ngModelChange)="onNgModelChange($event,'user-name-v')" autocomplete="off">
              </div>
            </ng-container>
            <ng-container *ngIf="oneQmsUsersFieldData.isAdUser">
              <div>
                <label for="userNameAd">{{dynamicLabel['USER_NAME']}}</label>
                <span class="mandatory-symbol">*</span>
              </div>
              <div>
                <input [disabled]="oneQmsUsersFieldData.isAdUser" id="userNameAd" class="input-filed-continers"
                  type="email" [(ngModel)]="oneQmsUsersFieldData.emailAddress" (input)="emailValidation()"
                  autocomplete="off">
                <div id="email-val-icon" class="field-icon-container"></div>
              </div>
            </ng-container>
          </div>
          <div class="col-md-3">
            <!-- First Name -->
            <div>
              <label for="firstName" id="first-name-v">{{dynamicLabel['FIRST_NAME']}}</label>
              <span class="mandatory-symbol">*</span>
            </div>
            <input id="firstName" class="input-filed-continers" type="text" [(ngModel)]="oneQmsUsersFieldData.firstName"
              (ngModelChange)="onNgModelChange($event,'first-name-v')" autocomplete="off">
          </div>
          <div class="col-md-3">
            <!-- Last Name -->
            <div><label for="lastName" id="last-name-v">{{dynamicLabel['LAST_NAME']}}</label><span
                class="mandatory-symbol">*</span></div>
            <input id="lastName" class="input-filed-continers" type="text" [(ngModel)]="oneQmsUsersFieldData.lastName"
              (ngModelChange)="onNgModelChange($event,'last-name-v')" autocomplete="off">
          </div>
          <div class="col-md-3">
            <!-- Contact Number -->
            <div><label for="contactNumber">Contact Number</label></div>
            <input id="contactNumber" class="input-filed-continers" type="number" min="1"
              [(ngModel)]="oneQmsUsersFieldData.contactNumber" (keydown)="validateNoOfDigitsFields($event)"
              autocomplete="off">
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <!-- Email Address -->
            <div>
              <label for="email" id="email-v">{{dynamicLabel['EMAIL_ADDRESS']}}</label>
              <span class="mandatory-symbol">*</span>
            </div>
            <input id="email" class="input-filed-continers" type="email" [(ngModel)]="oneQmsUsersFieldData.emailAddress"
              (input)="emailValidation()" (paste)="onEmailPaste($event)" autocomplete="off"
              (ngModelChange)="onNgModelChange($event,'email-v')">
            <div class="field-icon-container"></div>
            <span id="email-error-msg">Please enter a valid email</span>
          </div>
          <div class="col-md-3" *ngIf="message.organizationDetails?.adEnabled == 'Y'">
            <!-- {{dynamicLabel['isAdUser']}} -->
            <div><label for="email">Is AD User</label></div>
            <mat-slide-toggle color="primary" [(ngModel)]="oneQmsUsersFieldData.isAdUser"
              [disabled]="this.operationFlag != 'ADD'"
              [ngClass]="{'disabled-symbol': oneQmsUsersFieldData.isAdUser==true || oneQmsUsersFieldData.isAdUser==false}">
              <span class="active-inActive-container" *ngIf="oneQmsUsersFieldData.isAdUser==true"
                [ngStyle]="oneQmsUsersFieldData.isAdUser==true?{'color':'green'} : {'color': ''}">Yes</span>
              <span *ngIf="oneQmsUsersFieldData.isAdUser==false"
                [ngStyle]="oneQmsUsersFieldData.isAdUser==false?{'color':'red'} : {'color': ''}">No</span>
            </mat-slide-toggle>
          </div>


          <div class="col-md-3" *ngIf="visiblePasswordField && !oneQmsUsersFieldData.isAdUser">
            <!-- {{dynamicLabel['PASSWORD']}} -->
            <div><label for="pd-fleld" id="pd-v">Password</label><span class="mandatory-symbol">*</span></div>
            <input id="pd-fleld" class="input-filed-continers"
              [type]="changetypeAddAndEditPassword? 'password' : 'text' " [(ngModel)]="oneQmsUsersFieldData.password"
              onpaste="return false;" ondrop="return false;" noCopyPaste
              (ngModelChange)="onNgModelChange($event,'pd-v')" autocomplete="new-password">
            <span class="eyeicon-container" (click)="showPassword()" (keydown.enter)="showPassword()">
              <i
                [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash':'fa fa-fw fa-eye field-icon toggle-password'  "></i>
            </span>
            <div id="password-val-icon" class="field-icon-container"></div>
            <span id="password-required-msg">Please enter the password</span>
          </div>
          <div class="col-md-3" id="search-container">
            <!-- Manager -->
            <div>
              <label for="managerId" id="manager-v">{{dynamicLabel['MANAGER_NAME']}}</label>
              <span *ngIf="oneQmsUsersFieldData.isUserDeactivated" class="mandatory-symbol">*</span>
              <label *ngIf="oneQmsUsersFieldData.userStatus == 'Deactivation Approval Pending'" for="email"
                (click)="searchManagerFunction()" (keydown.enter)="searchManagerFunction()">
                <a>
                  <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Yes" width="25" height="25">
                </a>
              </label>
            </div>
            <span class="fa fa-search form-control-feedback" (click)="searchManagerFunction()"
              (keydown.enter)="searchManagerFunction()"></span>
            <input id="managerId" class="form-control" type="text" [(ngModel)]="oneQmsUsersFieldData.managerName"
              placeholder="Search"
              [disabled]="(oneQmsUsersFieldData.managerName == oneQmsUsersFieldData.managerName ? true : false)">
            <span id="manager-required-msg">While deactivating user , manager selection is necessary</span>
          </div>

        </div>

        <div class="row">
          <div class="col-md-3">
            <!-- Designation -->
            <div><label for="email">{{dynamicLabel['DESIGNATION']}}</label></div>
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedDesignationCode"
              [ngClass]="{'odd-item-mat-select': oddDesignationCode == selectedDesignationCode}"
              (closed)="designationsearchTxt=''" (click)="focusmethod('designationfocusSearch')"
              (keydown.enter)="focusmethod('designationfocusSearch')">
              <input type="search" id="designationfocussSearch" class="dropdownsearchstyle"
                [(ngModel)]="designationsearchTxt" matInput placeholder="Search">
              <mat-option class="unselectStyle" [value]="null"
                (onSelectionChange)="onDesignationCodeSelect($event,null);">Un-select</mat-option>
              <mat-option *ngFor="let item of designationCodeDropdown| assessmentSearch :designationsearchTxt;  "
                (onSelectionChange)="onDesignationCodeSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-3">
            <!-- Department -->
            <div><label for="email">{{dynamicLabel['DEPARTMENT']}}</label></div>
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedDepartmentCode"
              [ngClass]="{'odd-item-mat-select': oddDepartmentCode == selectedDepartmentCode}"
              (closed)="departmentsearchTxt=''" (click)="focusmethod('departmentfocusSearch')"
              (keydown.enter)="focusmethod('departmentfocusSearch')">
              <input type="search" id="departmentfocusSearchh" class="dropdownsearchstyle"
                [(ngModel)]="departmentsearchTxt" matInput placeholder="Search">
              <mat-option class="unselectStyle" [value]="null"
                (onSelectionChange)="onDepartmentCodeSelect($event,null);">Un-select</mat-option>
              <mat-option *ngFor="let item of departmentCodeDropdown| assessmentSearch :departmentsearchTxt"
                (onSelectionChange)="onDepartmentCodeSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-6">
            <!-- Timezone -->
            <div><label for="email">{{dynamicLabel['TIMEZONE']}}</label></div>
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedTimezoneValue"
              [ngClass]="{'odd-item-mat-select': oddTimezoneValue == selectedTimezoneValue}"
              (closed)="timeZonesearchTxt=''" (click)="focusmethod('timezonefocusSearch')"
              (keydown.enter)="focusmethod('timezonefocusSearch')">
              <input type="search" id="timezonefocusSearch" class="dropdownsearchstyle" [(ngModel)]="timeZonesearchTxt"
                matInput placeholder="Search">
              <mat-option class="unselectStyle" [value]="null"
                (onSelectionChange)="onTimeZoneSelect($event,null);">Un-select</mat-option>
              <mat-option *ngFor="let item of timezoneDropdown| assessmentSearch :timeZonesearchTxt"
                (onSelectionChange)="onTimeZoneSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>

        </div>

        <div id="row-container" class="row">
          <div class="col-md-3">
            <!-- {{dynamicLabel['COUNTRY']}} -->
            <div><label for="email">Country</label></div>
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedCountryValue"
              [ngClass]="{'odd-item-mat-select': oddCountryValue == selectedCountryValue}"
              (closed)="countrysearchTxt=''" (click)="focusmethod('countryfocusSearch')"
              (keydown.enter)="focusmethod('countryfocusSearch')">
              <input type="search" id="countryfocusSearch" class="dropdownsearchstyle" [(ngModel)]="countrysearchTxt"
                matInput placeholder="Search">
              <mat-option class="unselectStyle" [value]="null"
                (onSelectionChange)="onCountrySelect($event,null);">Un-select</mat-option>
              <mat-option *ngFor="let item of countryDropdown| assessmentSearch :countrysearchTxt"
                (onSelectionChange)="onCountrySelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>

          <div class="col-md-3">
            <!--{{dynamicLabel['CITY']}}  -->
            <div><label for="email">City</label></div>
            <input id="city" class="input-filed-continers" type="text" [(ngModel)]="oneQmsUsersFieldData.city">
          </div>
          <div class="col-md-3">
            <!-- {{dynamicLabel['PRIMARY_LANGUAGE']}} -->
            <div><label for="email">Primary Language</label></div>
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedPrimaryLanguageValue"
              [ngClass]="{'odd-item-mat-select': oddPrimaryLanguageValue == selectedPrimaryLanguageValue}"
              (closed)="primarylanguagesearchTxt=''" (click)="focusmethod('primarylanguagefocusSearch')"
              (keydown.enter)="focusmethod('primarylanguagefocusSearch')">
              <input type="search" id="primarylanguagefocusSearch" class="dropdownsearchstyle"
                [(ngModel)]="primarylanguagesearchTxt" matInput placeholder="Search">
              <mat-option class="unselectStyle" [value]="null"
                (onSelectionChange)="onPrimaryLanguageSelect($event,null);">Un-select</mat-option>
              <mat-option *ngFor="let item of primaryLanguageDropdown| assessmentSearch :primarylanguagesearchTxt"
                (onSelectionChange)="onPrimaryLanguageSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-3">
            <!-- User Status -->
            <div><label for="email">{{dynamicLabel['IS_ACTIVE']}}</label></div>
            <mat-slide-toggle color="primary" [(ngModel)]="oneQmsUsersFieldData.isActive" disabled
              [ngClass]="{'disabled-symbol': oneQmsUsersFieldData.isActive==true || oneQmsUsersFieldData.isActive==false}">
              <span class="active-inActive-container" *ngIf="oneQmsUsersFieldData.isActive==true"
                [ngStyle]="oneQmsUsersFieldData.isActive==true?{'color':'green'} : {'color': ''}">Active</span>
              <span *ngIf="oneQmsUsersFieldData.isActive==false"
                [ngStyle]="oneQmsUsersFieldData.isActive==false?{'color':'red'} : {'color': ''}">InActive</span>
            </mat-slide-toggle>
          </div>
          <div class="col-md-3">
            <!-- Last Name -->
            <div><label for="email">{{dynamicLabel['CLIENT_EMPLOYEE_ID']}}</label></div>
            <input class="input-filed-continers" type="text" [(ngModel)]="oneQmsUsersFieldData.clientEmployeeId">
          </div>
          <!-- Joining Date -->
          <div class="col-md-3 ">
            <div>
              <label for="joining-date">{{dynamicLabel['JOINING_DATE']}}</label>
              <!-- No mandatory symbol here since it's optional -->
            </div>
            <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="commonDateConfig"
              [dateCustomClasses]="dateCustomClasses" [(ngModel)]="oneQmsUsersFieldData.joiningDate"
              (ngModelChange)="onJoiningDateChange()">
          </div>
          <div class="col-md-3" *ngIf="visibleEditButton">
            <div><label for="email">{{ dynamicLabel['IS_USER_DEACTIVATED'] }}</label></div>

            <mat-slide-toggle color="primary" [(ngModel)]="oneQmsUsersFieldData.isUserDeactivated"
              [disabled]="(oneQmsUsersFieldData.userStatus =='Deactivation Approval Pending'|| oneQmsUsersFieldData.userStatus =='User Deactivated')"
              (change)="onUserDeactivationChange($event.checked)">
              <span class="active-inActive-container" *ngIf="oneQmsUsersFieldData.isUserDeactivated==true"
                [ngStyle]="oneQmsUsersFieldData.isUserDeactivated==true?{'color':'green'} : {'color': ''}">Yes</span>
              <span *ngIf="oneQmsUsersFieldData.isUserDeactivated==false"
                [ngStyle]="oneQmsUsersFieldData.isUserDeactivated==false?{'color':'red'} : {'color': ''}">No</span>
            </mat-slide-toggle>
          </div>
          <!-- Relieving Date -->
          <div class="col-md-3 " *ngIf="oneQmsUsersFieldData.isUserDeactivated">
            <div>
              <label for="relieving" id="relieving-date-v">{{dynamicLabel['RELIEVING_DATE']}}</label>
              <span *ngIf="oneQmsUsersFieldData.isUserDeactivated" class="mandatory-symbol">*</span>
            </div>
            <input type="text" id="relieving" class="form-control data-picker-continer" bsDatepicker
              [bsConfig]="$dynamicRelievingDateConfig()" [dateCustomClasses]="dateCustomClasses"
              [(ngModel)]="oneQmsUsersFieldData.relievingDate"
              (ngModelChange)="onNgModelChange($event,'relieving-date-v')">
            <span id="relieve-required-msg">While deactivating user , relieving date selection is necessary</span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <!-- {{dynamicLabel['USER_DESCRIPTION']}} -->
            <div><label for="email">User Description</label></div>
            <textarea id="userDescription" type="text" class="input-filed-textarea" rows="4" cols="50"
              [(ngModel)]="oneQmsUsersFieldData.userDescription"></textarea>
          </div>
          <div class="col-md-6" *ngIf="visibleReasonForUpdateField">
            <!-- Reason for Update -->
            <div><label for="email">{{dynamicLabel['UPDATE_REASON']}}</label><span class="mandatory-symbol">*</span>
            </div>
            <textarea id="updateReason" type="text" class="input-filed-textarea" rows="4" cols="50"
              [(ngModel)]="oneQmsUsersFieldData.updateReason"></textarea>
            <span id="updateReason-required-msg">Please provide the reason for update</span>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addAndEditFunction(oneQmsUsersFieldData,'ADD')"
      *ngIf="visibleAddButton">
      <i class="fas fa-plus"></i> Add
    </button>
    <button mat-stroked-button class="addButton" (click)="addAndEditFunction(oneQmsUsersFieldData ,'UPDATE')"
      *ngIf="visibleEditButton && !this.oneQmsUsersFieldData.isUserDeactivated && this.oneQmsUsersFieldData.isActive==true  ">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <ng-container *ngIf="sendForApprovalButton()">
      <button mat-stroked-button class="addButton" (click)="openPendingActivitiesPopup(selectedUserId)">
        <i class="fa fa-eye">
        </i>View Pending Activities
      </button>
      <button mat-stroked-button class="addButton" (click)="addAndEditFunction(oneQmsUsersFieldData,'DEACTIVATION')">
        <i class="fa-solid fa-user-slash"></i>Send for Deactivation Approval
      </button>
    </ng-container>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>

</ng-template>

<ng-template #activeAndInActivePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelActiveAndInActiveFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="row">
      <div class="col-md-12">
        <div><label for="email">{{ updateReasonLable }}</label><span class="mandatory-symbol">*</span></div>
        <textarea id="updateReason" type="text" class="input-filed-textarea" rows="4" cols="50"
          [(ngModel)]="oneQmsUsersFieldData.updateReason"></textarea>
        <span id="updateReason-required-msg">Please provide the {{updateReasonLable}}</span>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="activeAndInActiveFunction()" *ngIf="activeUserButton">
        <i class="fas fa-user-check"></i> Active
      </button>
      <button mat-stroked-button class="addButton" (click)="activeAndInActiveFunction()" *ngIf="inActiveUserButton">
        <i class="fas fa-user-minus"></i> Inactive
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelActiveAndInActiveFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #userconfig>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelUserPrivileges()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>

    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center px-3">
        <div class="dropdown">
        </div>
      </div>
      <div class="d-flex gap-3" style="padding: 10px 15px 0px 0px;">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openUserPrivlegesReport('Excel')" (keydown.enter)="openUserPrivlegesReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openUserPrivlegesReport('Pdf')" (keydown.enter)="openUserPrivlegesReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0,'PRIVILEGE')"
          (keydown.enter)="openAuditTrail('overAll',0,'PRIVILEGE')">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
      </div>
    </div>

    <div id="filed-container" class="form-continer" style="min-height: 470px !important">
      <div class="row">
        <div class="col-md-12">
          <div><label for="email">Functional Role</label></div>
          <mat-select matInput multiple placeholder="Select" #functionRoles [(ngModel)]="funcRoles"
            (closed)="functionalRolesSearchText=''" (click)="focusSearch('focus-func-roles-search')"
            (keydown.enter)="focusSearch('focus-func-roles-search')">
            <input type="search" id="focus-func-roles-search" class="dropdownsearchstyle"
              [(ngModel)]="functionalRolesSearchText" matInput placeholder="Search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isfunctionRoleSelected"
                (change)="toggleAllSelectionOthers('functionalRoles')">Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of commonRolesDropdown | multiAssessmentSearchPipe :functionalRolesSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onFunctionalRolesSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <fieldset class="border p-2" [hidden]="showQualitySection.length == 0">
        <legend class="float-none w-auto p-2"><span class="legent-title">Quality</span></legend>
        <div class="row">
          <div class="col-md-2">
            <div><label for="email">Is Quality User?</label></div>
            <mat-slide-toggle color="primary" [(ngModel)]="userprivData.isQualityUser"
              (change)="isQualityUserChanged($event)">
              <ng-container *ngIf="userprivData.isQualityUser; else no">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #no>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-10" *ngIf="userprivData.isQualityUser">
            <div><label for="email">Quality Roles</label></div>
            <mat-select matInput multiple placeholder="Select" #qualityRole [(ngModel)]="qualityUserRoles"
              (closed)="qualityRolesSearchText=''" (click)="focusSearch('focus-quality-roles-search')"
              (keydown.enter)="focusSearch('focus-quality-roles-search')">
              <input type="search" id="focus-quality-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="qualityRolesSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isQualityRoleSelected"
                  (change)="toggleAllSelectionOthers('qualityRole')">Select All</mat-checkbox>
              </div>
              <mat-option *ngFor="let item1 of qualityRoleDropdown | multiAssessmentSearchPipe :qualityRolesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onQualityRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-4" *ngIf="qualityUserRoles?.indexOf('Change Request User')!=-1">
            <div><label for="email">CR Roles</label></div>
            <mat-select matInput multiple placeholder="Select" #crRole [(ngModel)]="crRoles"
              (closed)="crRolesSearchText=''" (click)="focusSearch('focus-cr-roles-search')"
              (keydown.enter)="focusSearch('focus-cr-roles-search')">
              <input type="search" id="focus-cr-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="crRolesSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isCRRoleSelected" (change)="toggleAllSelectionOthers('crRole')">Select
                  All</mat-checkbox>
              </div>
              <mat-option
                *ngFor="let item1 of changeRequestRolesDropdown | multiAssessmentSearchPipe :crRolesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onCRRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-4" *ngIf="qualityUserRoles?.indexOf('CAPA User')!=-1  ">
            <div><label for="email">CAPA Roles</label></div>
            <mat-select matInput multiple placeholder="Select" #capaRole [(ngModel)]="capaRoles"
              (closed)="capaRolesSearchText=''" (click)="focusSearch('focus-capa-roles-search')"
              (keydown.enter)="focusSearch('focus-capa-roles-search')">
              <input type="search" id="focus-capa-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="capaRolesSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isCAPARoleSelected" (change)="toggleAllSelectionOthers('capaRole')">Select
                  All</mat-checkbox>
              </div>
              <mat-option *ngFor="let item1 of capaRolesDropdown | multiAssessmentSearchPipe :capaRolesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onCAPARolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-4" *ngIf="qualityUserRoles?.indexOf('Deviation User')!=-1  ">
            <div><label for="email">Deviation Roles</label></div>
            <mat-select matInput multiple placeholder="Select" #deviationRole [(ngModel)]="dvRoles"
              (closed)="deviationRolesSearchText=''" (click)="focusSearch('focus-deviation-roles-search')"
              (keydown.enter)="focusSearch('focus-deviation-roles-search')">
              <input type="search" id="focus-deviation-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="deviationRolesSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isDeviationRoleSelected"
                  (change)="toggleAllSelectionOthers('deviationRoles')">Select All</mat-checkbox>
              </div>
              <mat-option
                *ngFor="let item1 of deviationRolesDropdown | multiAssessmentSearchPipe :deviationRolesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="ondeviationRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-4" *ngIf="qualityUserRoles?.indexOf('Audit User')!=-1 ">
            <div><label for="email">Audit Roles</label></div>
            <mat-select matInput multiple placeholder="Select" #auditRole [(ngModel)]="auRoles"
              (closed)="auditRolesSearchText=''" (click)="focusSearch('focus-audit-roles-search')"
              (keydown.enter)="focusSearch('focus-audit-roles-search')">
              <input type="search" id="focus-audit-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="auditRolesSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isAuditRoleSelected" (change)="toggleAllSelectionOthers('auditRoles')">Select
                  All</mat-checkbox>
              </div>

              <mat-option *ngFor="let item1 of auditRolesDropdown| multiAssessmentSearchPipe :auditRolesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onAuditRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-4" *ngIf="qualityUserRoles?.indexOf('Customer Complaint User')!=-1  ">
            <div><label for="email">Customer Complaint Roles</label></div>
            <mat-select matInput multiple placeholder="Select" #customerComplaintRole [(ngModel)]="ccRoles"
              (closed)="customerCompRolesSearchText=''" (click)="focusSearch('focus-customerComp-roles-search')"
              (keydown.enter)="focusSearch('focus-customerComp-roles-search')">
              <input type="search" id="focus-customerComp-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="customerCompRolesSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isCustomerCompRoleSelected"
                  (change)="toggleAllSelectionOthers('customerCompRoles')">Select All</mat-checkbox>
              </div>

              <mat-option
                *ngFor="let item1 of customerComplaiesRolesDropdown | multiAssessmentSearchPipe :customerCompRolesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onCustomerCompRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-4" *ngIf="qualityUserRoles?.indexOf('Incident User')!=-1  ">
            <div><label for="email">Incident Roles</label></div>
            <mat-select matInput multiple placeholder="Select" #incidentRole [(ngModel)]="inRoles"
              (closed)="incidentRolesSearchText=''" (click)="focusSearch('focus-incident-roles-search')"
              (keydown.enter)="focusSearch('focus-incident-roles-search')">
              <input type="search" id="focus-incident-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="incidentRolesSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isIncidentRoleSelected"
                  (change)="toggleAllSelectionOthers('incidentRoles')">Select All</mat-checkbox>
              </div>
              <mat-option
                *ngFor="let item1 of incidentRolesDropdown | multiAssessmentSearchPipe :incidentRolesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onIncidentRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-4" *ngIf="qualityUserRoles?.indexOf('Quality Issue User')!=-1  ">
            <div><label for="email">QI Roles</label></div>
            <mat-select matInput multiple placeholder="Select" #qiRole [(ngModel)]="qiRoles"
              (closed)="qiRolesSearchText=''" (click)="focusSearch('focus-qi-roles-search')"
              (keydown.enter)="focusSearch('focus-qi-roles-search')">
              <input type="search" id="focus-qi-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="qiRolesSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isQIRoleSelected" (change)="toggleAllSelectionOthers('qiRoles')">Select
                  All</mat-checkbox>
              </div>

              <mat-option *ngFor="let item1 of qiRolesDropdown | multiAssessmentSearchPipe :qiRolesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onQIRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-4" *ngIf="qualityUserRoles?.indexOf('Out of Specification User')!=-1  ">
            <div><label for="email">OOS Roles</label></div>
            <mat-select matInput multiple placeholder="Select" #oosRole [(ngModel)]="oosRoles"
              (closed)="oosRolesSearchText=''" (click)="focusSearch('focus-qi-roles-search')"
              (keydown.enter)="focusSearch('focus-qi-roles-search')">
              <input type="search" id="focus-roles-search" class="dropdownsearchstyle" [(ngModel)]="oosRolesSearchText"
                matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isOOSRoleSelected" (change)="toggleAllSelectionOthers('oosRoles')">Select
                  All</mat-checkbox>
              </div>

              <mat-option *ngFor="let item1 of oosRolesDropdown | multiAssessmentSearchPipe :oosRolesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onQIRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </fieldset>

      <fieldset class="border p-2" [hidden]="showDocsSection.length == 0">
        <legend class="float-none w-auto p-2"><span class="legent-title">Documents</span></legend>
        <div class="row">
          <div class="col-md-2">
            <div><label for="email">Is Documents User?</label></div>
            <mat-slide-toggle color="primary" [(ngModel)]="userprivData.isDocumentUser"
              (change)="isDocumentsUserChanged($event)">
              <ng-container *ngIf="userprivData.isDocumentUser; else no">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #no>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-10" *ngIf="userprivData.isDocumentUser">
            <div><label for="email">Documents Roles</label></div>
            <mat-select matInput multiple placeholder="Select" #documentRole [(ngModel)]="documentUserRoles"
              (closed)="documentRolesSearchText=''" (click)="focusSearch('focus-document-roles-search')"
              (keydown.enter)="focusSearch('focus-document-roles-search')">
              <input type="search" id="focus-document-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="documentRolesSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isDocumentRoleSelected"
                  (change)="toggleAllSelectionOthers('documentRoles')">Select All</mat-checkbox>
              </div>

              <mat-option
                *ngFor="let item1 of documentsRolesDropdown | multiAssessmentSearchPipe :documentRolesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onDocumentRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </fieldset>

      <fieldset class="border p-2" [hidden]="showTrnsSection.length == 0">
        <legend class="float-none w-auto p-2"><span class="legent-title">Training</span></legend>
        <div class="row">
          <div class="col-md-2">
            <div><label for="email">Is Training User?</label></div>
            <mat-slide-toggle color="primary" [(ngModel)]="userprivData.isTrainingUser"
              (change)="isTrainingsUserChanged($event)">
              <ng-container *ngIf="userprivData.isTrainingUser; else no">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #no>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-10" *ngIf="userprivData.isTrainingUser">
            <div><label for="email">Training User Roles</label></div>
            <mat-select matInput multiple placeholder="Select" #trainingUserRole [(ngModel)]="trainingUserRoles"
              (closed)="trainingUserRolesSearchText=''" (click)="focusSearch('focus-trainingUserRoles-roles-search')"
              (keydown.enter)="focusSearch('focus-trainingUserRoles-roles-search')">
              <input type="search" id="focus-trainingUser-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="trainingUserRolesSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isTrainingUserRoleSelected"
                  (change)="toggleAllSelectionOthers('trainingUserRoles')">Select All</mat-checkbox>
              </div>

              <mat-option
                *ngFor="let item1 of trainingsRolesDropdown | multiAssessmentSearchPipe :trainingUserRolesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="ontrainingUserRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </fieldset>

      <fieldset class="border p-2" [hidden]="!trn" *ngIf="userprivData.isTrainingUser">
        <legend class="float-none w-auto p-2"><span class="legent-title">Training Categories</span></legend>
        <div class="row">
          <div class="col-md-4">
            <div><label for="email">Author Categories</label></div>
            <mat-select matInput multiple placeholder="Select" #authorCategoires [(ngModel)]="trainingAuthorCategories"
              (closed)="authorCategoiresSearchText=''" (click)="focusSearch('focus-authorCategoires-roles-search')"
              (keydown.enter)="focusSearch('focus-authorCategoires-roles-search')">
              <input type="search" id="focus-authorCategoires-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="authorCategoiresSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isAuthorCategoiresSelected"
                  (change)="toggleAllSelectionOthers('authorCategoires')">Select All</mat-checkbox>
              </div>

              <mat-option
                *ngFor="let item1 of TrainingCategorySubgroupsDropdown | multiAssessmentSearchPipe :authorCategoiresSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onAuthorCategoiresUserRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-4">
            <div><label for="email">Reviewer/Approver Categories</label></div>
            <mat-select matInput multiple placeholder="Select" #reviewAndAppCateg
              [(ngModel)]="trainingReviewerApproverCategories" (closed)="reviewAndAppCategSearchText=''"
              (click)="focusSearch('focus-reviewAndAppCateg-roles-search')"
              (keydown.enter)="focusSearch('focus-reviewAndAppCateg-roles-search')">
              <input type="search" id="focus-reviewAndAppCateg-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="reviewAndAppCategSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isReviewAndAppCategSelected"
                  (change)="toggleAllSelectionOthers('reviewAndAppCateg')">Select All</mat-checkbox>
              </div>
              <mat-option
                *ngFor="let item1 of TrainingCategorySubgroupsDropdown | multiAssessmentSearchPipe :reviewAndAppCategSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onReviewAndAppCategUserRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </fieldset>
      <fieldset class="border p-2" [hidden]="showFormsSection.length == 0">
        <legend class="float-none w-auto p-2"><span class="legent-title">Forms and Logs</span></legend>
        <div class="row">
          <div class="col-md-2">
            <div><label for="email">Is Forms and Logs User?</label></div>
            <mat-slide-toggle color="primary" [(ngModel)]="userprivData.isFormsAndLogsUser"
              (change)="isFormsAndLogsChanged($event)">
              <ng-container *ngIf="userprivData.isFormsAndLogsUser; else no">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #no>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-10" *ngIf="userprivData.isFormsAndLogsUser">
            <div><label for="email">Forms and Logs Roles</label></div>
            <mat-select matInput multiple placeholder="Select" #formAndLogsRoles [(ngModel)]="formsLogsUserRoles"
              (closed)="formAndLogsRolesSearchText=''" (click)="focusSearch('focus-formAndLogsRoles-roles-search')"
              (keydown.enter)="focusSearch('focus-formAndLogsRoles-roles-search')">
              <input type="search" id="focus-formAndLogsRoles-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="formAndLogsRolesSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isFormAndLogsRolesSelected"
                  (change)="toggleAllSelectionOthers('formAndLogsRoles')">Select All</mat-checkbox>
              </div>
              <mat-option
                *ngFor="let item1 of formsLogsRolesDropdown | multiAssessmentSearchPipe : formAndLogsRolesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onFormAndLogsRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </fieldset>
      <fieldset class="border p-2" [hidden]="!(showbpSection.length > 0 && bp)">
        <legend class="float-none w-auto p-2"><span class="legent-title">Business Process</span></legend>
        <div class="row">
          <div class="col-md-2">
            <div><label for="email">Is Business Process User?</label></div>
            <mat-slide-toggle color="primary" [(ngModel)]="userprivData.isBpUser" (change)="isBpUserChanged($event)">
              <ng-container *ngIf="userprivData.isBpUser; else no">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #no>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-10" *ngIf="userprivData.isBpUser">
            <div><label for="email">Business Process Roles</label></div>
            <mat-select matInput multiple placeholder="Select" #businessProcessRoles [(ngModel)]="bpUserRoles"
              (closed)="businessProcessRolesSearchText=''"
              (click)="focusSearch('focus-businessProcessRoles-roles-search')"
              (keydown.enter)="focusSearch('focus-businessProcessRoles-roles-search')">
              <input type="search" id="focus-businessProcessRoles-roles-search" class="dropdownsearchstyle"
                [(ngModel)]="businessProcessRolesSearchText" matInput placeholder="Search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isBusinessProcessRolesSelected"
                  (change)="toggleAllSelectionOthers('businessProcessRoles')">Select All</mat-checkbox>
              </div>

              <mat-option
                *ngFor="let item1 of bpRolesDropdown | multiAssessmentSearchPipe : businessProcessRolesSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onBusinessProcessRolesSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </fieldset>
      <div class="col-md-6">
        <div>
          <label for="updateReason" id="update-reason">Update Reason</label>
          <span class="mandatory-symbol">*</span>
        </div>
        <textarea id="updateReason" rows="4" class="input-filed-textarea" type="text"
          [(ngModel)]="userprivData.updateReason" (ngModelChange)="onNgModelChange($event,'update-reason')"></textarea>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addUserPrivileges()">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelUserPrivileges()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #searchManager>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchManagerFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-continer filed-container">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" [(ngModel)]="searchByUserName">
        <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByFirstName">
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByLastName">
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Email Address</label></div>
        <input class="input-filed-continers" type="email" [(ngModel)]="searchByemailAddress">
      </div>
      <div class="col-md-3">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="designationCodeValue" (closed)="designationsearchTxt=''"
          (click)="focusmethod('designationfocusSearch')" (keydown.enter)="focusmethod('designationfocusSearch')">
          <input type="search" id="designationfocuSearch" class="dropdownsearchstyle" [(ngModel)]="designationsearchTxt"
            matInput placeholder="Search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDesignationCodeSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of designationCodeDropdown| assessmentSearch :designationsearchTxt"
            (onSelectionChange)="onDesignationCodeSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="departmentCodeValue" (closed)="departmentsearchTxt=''"
          (click)="focusmethod('departmentfocusSearch')" (keydown.enter)="focusmethod('departmentfocusSearch')">
          <input type="search" id="departmentSearch" class="dropdownsearchstyle" [(ngModel)]="departmentsearchTxt"
            matInput placeholder="Search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDepartmentCodeSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch :departmentsearchTxt"
            (onSelectionChange)="onDepartmentCodeSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row">
      <div class="search-button-continer" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchManagerGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchManagerGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container" style="height: 50vh;">
        <thead>
          <th style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div>
                <i class="fa-solid fa-ellipsis-vertical parent-menu-icons"></i>
              </div>
              <div style="margin-left: 5px;">
              </div>
            </div>
          </th>
          <th> <span>User Name</span> <span class="fa-solid fa-filter" class="multi-filter-container"></span> </th>
          <th> <span>First Name</span> <span class="fa-solid fa-filter" class="multi-filter-container"></span> </th>
          <th> <span>Last Name</span> <span class="fa-solid fa-filter" class="multi-filter-container"></span> </th>
          <th> <span>User Full Name</span> <span class="fa-solid fa-filter" class="multi-filter-container"></span> </th>
          <th> <span>Designation</span> <span class="fa-solid fa-filter" class="multi-filter-container"></span> </th>
          <th> <span>Department</span> <span class="fa-solid fa-filter" class="multi-filter-container"></span> </th>
          <th> <span>EmailAddress</span> <span class="fa-solid fa-filter" class="multi-filter-container"></span> </th>
          <th> <span>Contact Number</span> <span class="fa-solid fa-filter" class="multi-filter-container"></span> </th>
          <th> <span>Manager Name</span> <span class="fa-solid fa-filter" class="multi-filter-container"></span> </th>
          <th> <span>Is AD User</span> <span class="fa-solid fa-filter" class="multi-filter-container"></span> </th>
          <th> <span>Is Factory User</span> <span class="fa-solid fa-filter" class="multi-filter-container"></span>
          </th>
          <th> <span>Is Active</span> <span class="fa-solid fa-filter" class="multi-filter-container"></span> </th>
          <th id="menus" class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <tr class="data-row-container"
            *ngFor="let listOfUsersVwDetails of getOneQmsUsersVwDetailsTableData; let idx = index;"
            [class.highlightRow]="listOfUsersVwDetails.searchManagerChildCheckBoxs == true">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="listOfUsersVwDetails.searchManagerChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input id="selectedManagerCheckBox" type="checkbox" style="zoom: 1.2;"
                    [checked]="listOfUsersVwDetails.searchManagerChildCheckBoxs"
                    (change)="searchManagerChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ listOfUsersVwDetails.userName }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.firstName }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.lastName }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.userFullName }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.designation }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.department }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.emailAddress }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.contactNumber }}</td>
            <td class="row-data">{{ listOfUsersVwDetails.managerName }}</td>
            <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
                type="checkbox" [(ngModel)]="listOfUsersVwDetails.isAdUser"> </td>
            <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
                type="checkbox" [(ngModel)]="listOfUsersVwDetails.isFactoryUser"> </td>
            <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
                type="checkbox" [(ngModel)]="listOfUsersVwDetails.isActive"> </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions *ngIf="showUserSearchGrid">
    <button mat-stroked-button class="addButton"
      *ngIf="oneQmsUsersFieldData.userStatus != 'Deactivation Approval Pending'" (click)=" addManagerNameFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="addButton"
      *ngIf="oneQmsUsersFieldData.userStatus == 'Deactivation Approval Pending'"
      (click)="addAndEditFunction(oneQmsUsersFieldData ,'UPDATE')">
      <i class="fas fa-check"></i> Add & Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchManagerFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #reset>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelresetFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="row">
      <div class="col-md-12">
        <div><label for="email ">User Name</label></div>
        <input class="input-filed-continers uppercase" type="text" [(ngModel)]="resetData.userName" disabled="true">
      </div>
      <div class="col-md-12">
        <div><label for="email">Password</label><span class="mandatory-symbol">*</span></div>
        <input id="reset-password" class="input-filed-continers"
          [type]="changetypeNewPasswordInResetPopup? 'password' : 'text' " [(ngModel)]="resetData.newPassword"
          onpaste="return false;" ondrop="return false;" noCopyPaste>
        <span class="eyeicon-container" (click)="showNewPasswordInResetPopup()"
          (keydown.enter)="showNewPasswordInResetPopup()">
          <i
            [class]="changetypeNewPasswordInResetPopup ?  'fas fa-eye-slash':'fa fa-fw fa-eye field-icon toggle-password' "></i>
        </span>
        <span id="reset-password-required-msg">Please enter the password</span>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="resetFunction(resetData)">
        <i class="fas fa-check"></i> Reset
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelresetFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>

<ng-template #uploadImagesPopup1>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelUploadLogoFunction()" mat-button><i
      style="font-size: 23px;color: blue;" class="fa">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }} </label>
  </div>
  <div style="margin: 10px 10px;">
    <div class="row">
      <div class="col-md-12" id="upload-btn-wrapper">
        <input id="uploadInputValue" type="file" name="myfile" (change)="uploadImages($event);readURL($event)" />

        <div class="upload-val-container d-flex justify-content-center">
          <span id="logo-success-icon" class="far fa-check-circle"></span><span id="logo-success-msg">Image
            chosen</span>
          <span id="logo-error-icon" class="fas fa-exclamation-circle"></span><span id="logo-error-msg">Please upload
            JPG/JPEG or PNG images only</span>
          <span id="logo-required-icon" class="fas fa-exclamation-circle"></span><span id="logo-required-msg">Please
            upload the image</span>
          <span *ngIf="logosizeextended">
            <span class="fas fa-exclamation-circle"></span>
            <span>File size exceeds the limit (500KB). Please choose a smaller file</span>
          </span>
        </div>
        <div *ngIf="profileImage" class="row" style="justify-content:center;">
          <img alt="profile" [src]="profileImage" style="height:150px;width:160px;" />
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer" mat-dialog-actions>
    <button mat-stroked-button class="uploadButton" (click)="uploadLogoImage()">
      <i class="fas fa-upload"></i> Upload
    </button>
  </div>
</ng-template>

<ng-template #trailPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeTrailPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="email" class="popupTitle"> Audit Trail </label>
    <label for="email" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="audit-block-container">
    <div class="audit-block" (click)="auditTrailBlocks(0)" (keydown.enter)="auditTrailBlocks(0)">
      OverAll
    </div>
    <div class="audit-block" (click)="auditTrailBlocks(1)" (keydown.enter)="auditTrailBlocks(1)">
      Quality
    </div>
    <div class="audit-block" (click)="auditTrailBlocks(2)" (keydown.enter)="auditTrailBlocks(2)">
      Trainings
    </div>
    <div class="audit-block" (click)="auditTrailBlocks(3)" (keydown.enter)="auditTrailBlocks(3)">
      Documents
    </div>
    <div class="audit-block" (click)="auditTrailBlocks(4)" (keydown.enter)="auditTrailBlocks(4)">
      Forms and Logs
    </div>
    <div class="audit-block" (click)="auditTrailBlocks(5)" (keydown.enter)="auditTrailBlocks(5)">
      Business Process
    </div>
  </div>
</ng-template>

<ng-template #reportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeUserPrivilegesReport()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="email" class="popupTitle"> {{reportType}}&nbsp;Report </label>
    <label for="email" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div class="audit-block-container">
    <div class="audit-block" (click)="reportBlocks(0)" (keydown.enter)="reportBlocks(0)">
      OverAll
    </div>
    <div class="audit-block" (click)="reportBlocks(1)" (keydown.enter)="reportBlocks(1)">
      Quality
    </div>
    <div class="audit-block" (click)="reportBlocks(2)" (keydown.enter)="reportBlocks(2)">
      Trainings
    </div>
    <div class="audit-block" (click)="reportBlocks(3)" (keydown.enter)="reportBlocks(3)">
      Documents
    </div>
    <div class="audit-block" (click)="reportBlocks(4)" (keydown.enter)="reportBlocks(4)">
      Forms and Logs
    </div>
    <div class="audit-block" (click)="reportBlocks(5)" (keydown.enter)="reportBlocks(5)">
      Business Process
    </div>
  </div>
</ng-template>

<ng-template #pendingActivitiesPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closePendingActivitiesPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Pending Activities of&nbsp;&nbsp;{{oneQmsUsersFieldData.userName}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="pending-activities-popup form-continer" style="max-height:610px !important">

    <div class=" row">
      <ng-container *ngIf="pendingActivitiesGridLength; else no">
        There are about {{pendingActivitiesGridLength}}&nbsp; activities pending with this user
      </ng-container>
      <ng-template #no>
        There are no activities pending with this user
      </ng-template>
    </div><br />
    <ng-container>
      <app-dynamic-grid *ngIf="gridConfig && gridClause && gridTrail && gridReport && gridSettings"
        [config]="gridConfig" [clauses]="gridClause" [trail]="gridTrail" [report]="gridReport" [settings]="gridSettings"
        (refreshed)="onGridRefresh($event)"></app-dynamic-grid>
    </ng-container>
  </div>
</ng-template>

<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>
